import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { MarketdateMeterreading } from './marketdate-meterreading.model';
import { MarketdateMeterreadingService } from './marketdate-meterreading.service';
@Injectable()
export class MarketdateMeterreadingPopupService {
    private isOpen = false;
    constructor(
        private datePipe: DatePipe,
        private modalService: NgbModal,
        private router: Router,
        private marketdateMeterreadingService: MarketdateMeterreadingService

    ) {}

    open(component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.marketdateMeterreadingService.find(id).subscribe((marketdateMeterreading) => {
                marketdateMeterreading.timestamp = this.datePipe
                    .transform(marketdateMeterreading.timestamp, 'yyyy-MM-ddThh:mm');
                marketdateMeterreading.updated = this.datePipe
                    .transform(marketdateMeterreading.updated, 'yyyy-MM-ddThh:mm');
                marketdateMeterreading.created = this.datePipe
                    .transform(marketdateMeterreading.created, 'yyyy-MM-ddThh:mm');
                this.marketdateMeterreadingModalRef(component, marketdateMeterreading);
            });
        } else {
            return this.marketdateMeterreadingModalRef(component, new MarketdateMeterreading());
        }
    }

    marketdateMeterreadingModalRef(component: Component, marketdateMeterreading: MarketdateMeterreading): NgbModalRef {
        const modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static'});
        modalRef.componentInstance.marketdateMeterreading = marketdateMeterreading;
        modalRef.result.then((result) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-meterreading/marketdate-meterreading-popup.service.ts